import { createAction, props } from '@ngrx/store';
import {
  AssignmentViewModel,
  BusinessUnitViewModel,
  DADeliverableTemplateViewModel,
  FileParameter,
  FocusAreaConfigViewModel,
  GlobalSettingsValueRecognitionViewModel,
  MandatoryCheckImportResultViewModel,
  MandatoryCheckTemplateViewModel,
  SMEDisciplineConfigViewModel,
} from 'src/app/shared/models/autogenerated';

export const loadGlobalSettingsValueRecognition = createAction(
  '[Global Settings] Load Global Settings Value Recognition'
);

export const updateGlobalSettingsValueRecognition = createAction(
  '[Global Settings] Update Global Settings Value Recognition'
);

export const setGlobalSettingsValueRecognition = createAction(
  '[Global Settings] Set Global Settings Value Recognition',
  props<{
    globalSettingsValueRecognition: GlobalSettingsValueRecognitionViewModel[];
  }>()
);

export const clearGlobalSettingsValueRecognition = createAction(
  '[Global Settings] Clear Global Settings Value Recognition'
);

export const returnSavedGlobalSettingsValueRecognition = createAction(
  '[Global Settings] Return to Saved Global Settings Value Recognition'
);

export const loadAllMandatoryChecksTemplates = createAction(
  '[Global Settings] Load All Mandatory Checks Templates'
);

export const setAllMandatoryChecksTemplates = createAction(
  '[Global Settings] Set All Mandatory Checks Templates',
  props<{ mandatoryChecksTemplates: MandatoryCheckTemplateViewModel[] }>()
);

export const loadMandatoryCheckTemplate = createAction(
  '[Global Settings] Load Mandatory Check Template',
  props<{ mandatoryCheckTemplateId: string }>()
);

export const setMandatoryCheckTemplateForm = createAction(
  '[Global Settings] Set Mandatory Check Template Form',
  props<{ mandatoryCheckTemplate: MandatoryCheckTemplateViewModel }>()
);

export const clearMandatoryCheckTemplateForm = createAction(
  '[Global Settings] Clear Mandatory Check Template Form'
);

export const createMandatoryCheckTemplateFromForm = createAction(
  '[Global Settings] Create Mandatory Check Template from Form'
);

export const createMandatoryCheckTemplateFromFormSuccess = createAction(
  '[Global Settings] Create Mandatory Check Template from Form Success',
  props<{ mandatoryCheckTemplate: MandatoryCheckTemplateViewModel }>()
);

export const deleteMandatoryCheckTemplate = createAction(
  '[Global Settings] Delete Mandatory Check Template',
  props<{ mandatoryCheckTemplateId: string }>()
);

export const deleteMandatoryCheckTemplateSuccess = createAction(
  '[Global Settings] Delete Mandatory Check Template Success'
);

export const updateMandatoryCheckTemplateForm = createAction(
  '[Global Settings] Update Mandatory Check Template from Form',
  props<{ mandatoryCheckTemplateId: string }>()
);

export const updateMandatoryCheckTemplateFormSuccess = createAction(
  '[Global Settings] Update Mandatory Check Template from Form Success',
  props<{ mandatoryCheckTemplate: MandatoryCheckTemplateViewModel }>()
);

export const loadAllPhases = createAction('[Global Settings] Load All Phases');

export const setAllPhases = createAction(
  '[Global Settings] Set All Phases',
  props<{ allPhases: string[] }>()
);

export const syncAllGlobalAdminsAccess = createAction(
  '[Global Settings] Sync All Global Admin Access',
  props<{ globalAdminsIds: string[] }>()
);

export const syncAllGlobalAdminsAccessSuccess = createAction(
  '[Global Settings] Sync All Global Admin Access Success',
  props<{ globalAdminsIds: string[] }>()
);

export const loadAllPeerPoolDisciplines = createAction(
  '[Global Settings] Load All Peer Pool Disciplines'
);

export const deletePeerPoolDiscipline = createAction(
  '[Global Settings] Delete Peer Pool Discipline',
  props<{ peerPoolDisciplineId: string }>()
);

export const deletePeerPoolDisciplineSuccess = createAction(
  '[Global Settings] Delete Peer Pool Discipline Success'
);

export const setAllPeerPoolDisciplines = createAction(
  '[Global Settings] Set All Peer Pool Disciplines',
  props<{ peerPoolDisciplines: SMEDisciplineConfigViewModel[] }>()
);

export const updatePeerPoolDiscipline = createAction(
  '[Global Settings] Update Peer Pool Discipline from Form',
  props<{ peerPoolDisciplineId: string }>()
);

export const updatePeerPoolDisciplineSuccess = createAction(
  '[Global Settings] Update Peer Pool Discipline from Form Success',
  props<{ peerPoolDiscipline: SMEDisciplineConfigViewModel }>()
);

export const clearPeerPoolDisciplineForm = createAction(
  '[Global Settings] Clear Peer Pool Discipline Form'
);

export const createPeerPoolDiscipline = createAction(
  '[Global Settings] Create Peer Pool Discipline from Form'
);

export const createPeerPoolDisciplineSuccess = createAction(
  '[Global Settings] Create Peer Pool Discipline from Form Success',
  props<{ peerPoolDiscipline: SMEDisciplineConfigViewModel }>()
);

export const loadPeerPoolDiscipline = createAction(
  '[Global Settings] Load Peer Pool Discipline',
  props<{ peerPoolDisciplineId: string }>()
);

export const setPeerPoolDisciplineForm = createAction(
  '[Global Settings] Set Peer Pool Discipline Form',
  props<{ peerPoolDiscipline: SMEDisciplineConfigViewModel }>()
);

export const importMandatoryChecksSuccess = createAction(
  '[Global Settings] Import Mandatory Checks Success',
  props<{
    mandatoryChecks: MandatoryCheckImportResultViewModel | null;
  }>()
);

export const importMandatoryChecks = createAction(
  '[Global Settings] Import',
  props<{
    file: FileParameter;
    onlyAdd: boolean;
    insertMissing: boolean;
    removeDeleted: boolean;
    updateExisting: boolean;
  }>()
);

export const syncAllExceptionsAccess = createAction(
  '[Global Settings] Sync All Exception Access',
  props<{ exceptionsIds: string[] }>()
);

export const syncAllExceptionsAccessSuccess = createAction(
  '[Global Settings] Sync All Exception Access Success',
  props<{ exceptionsIds: string[] }>()
);

export const loadAllDADeliverablesTemplates = createAction(
  '[Global Settings] Load All DA Deliverables Templates'
);

export const setAllDADeliverablesTemplates = createAction(
  '[Global Settings] Set All DA Deliverables Templates',
  props<{ daDeliverablesTemplates: DADeliverableTemplateViewModel[] }>()
);

export const loadDADeliverableTemplate = createAction(
  '[Global Settings] Load DA Deliverable Template',
  props<{ daDeliverableTemplateId: string }>()
);

export const setDADeliverableTemplateForm = createAction(
  '[Global Settings] Set DA Deliverable Template Form',
  props<{ daDeliverableTemplate: DADeliverableTemplateViewModel }>()
);

export const clearDADeliverableTemplateForm = createAction(
  '[Global Settings] Clear DA Deliverable Template Form'
);

export const createDADeliverableTemplateFromForm = createAction(
  '[Global Settings] Create DA Deliverable Template from Form'
);

export const createDADeliverableTemplateFromFormSuccess = createAction(
  '[Global Settings] Create DA Deliverable Template from Form Success',
  props<{ daDeliverableTemplate: DADeliverableTemplateViewModel }>()
);

export const deleteDADeliverableTemplate = createAction(
  '[Global Settings] Delete DA Deliverable Template',
  props<{ daDeliverableTemplateId: string }>()
);

export const deleteDADeliverableTemplateSuccess = createAction(
  '[Global Settings] Delete DA Deliverable Template Success'
);

export const updateDADeliverableTemplateForm = createAction(
  '[Global Settings] Update DA Deliverable Template from Form',
  props<{ daDeliverableTemplateId: string }>()
);

export const updateDADeliverableTemplateFormSuccess = createAction(
  '[Global Settings] Update DA Deliverable Template from Form Success',
  props<{ daDeliverableTemplate: DADeliverableTemplateViewModel }>()
);

export const loadSMEDisciplineConfigCodes = createAction(
  '[Global Settings] Load SME Discipline Config Codes'
);

export const setSMEDisciplineConfigCodesSuccess = createAction(
  '[Global Settings] set SME Discipline Config Codes Success',
  props<{ codes: string[] | null }>()
);

export const loadAllBusinessUnits = createAction(
  '[Global Settings] Load All Business Units'
);

export const setAllBusinessUnits = createAction(
  '[Global Settings] Set All Business Units',
  props<{ businessUnits: BusinessUnitViewModel[] }>()
);

export const loadBusinessUnit = createAction(
  '[Global Settings] Load Business Unit',
  props<{ businessUnitId: string }>()
);

export const setBusinessUnitForm = createAction(
  '[Global Settings] Set Business Unit Form',
  props<{ businessUnit: BusinessUnitViewModel }>()
);

export const clearBusinessUnitForm = createAction(
  '[Global Settings] Clear Business Unit Form'
);

export const createBusinessUnitFromForm = createAction(
  '[Global Settings] Create Business Unit from Form'
);

export const createBusinessUnitFromFormSuccess = createAction(
  '[Global Settings] Create Business Unit from Form Success',
  props<{ businessUnit: BusinessUnitViewModel }>()
);

export const deleteBusinessUnit = createAction(
  '[Global Settings] Delete Business Unit',
  props<{ businessUnitId: string }>()
);

export const deleteBusinessUnitSuccess = createAction(
  '[Global Settings] Delete Business Unit Success'
);

export const updateBusinessUnitForm = createAction(
  '[Global Settings] Update Business Unit from Form',
  props<{ businessUnitId: string }>()
);

export const updateBusinessUnitFormSuccess = createAction(
  '[Global Settings] Update Business Unit from Form Success',
  props<{ businessUnit: BusinessUnitViewModel }>()
);

export const getAssignments = createAction('[Global Settings] Get Assignments');

export const setAssignments = createAction(
  '[Global Settings] Assignments Loaded Success',
  props<{ assignments: AssignmentViewModel[] | null }>()
);

export const loadAllFocusAreaConfigs = createAction(
  '[Global Settings] Load All Focus Area Configs'
);

export const setAllFocusAreaConfigs = createAction(
  '[Global Settings] Set All Focus Area Configs',
  props<{ focusAreaConfigs: FocusAreaConfigViewModel[] }>()
);

export const loadFocusAreaConfig = createAction(
  '[Global Settings] Load Focus Area Config',
  props<{ focusAreaConfigId: string }>()
);

export const setFocusAreaConfigForm = createAction(
  '[Global Settings] Set Focus Area Config Form',
  props<{ focusAreaConfig: FocusAreaConfigViewModel }>()
);

export const clearFocusAreaConfigForm = createAction(
  '[Global Settings] Clear Focus Area Config Form'
);

export const createFocusAreaConfigFromForm = createAction(
  '[Global Settings] Create Focus Area Config from Form'
);

export const createFocusAreaConfigFromFormSuccess = createAction(
  '[Global Settings] Create Focus Area Config from Form Success',
  props<{ focusAreaConfig: FocusAreaConfigViewModel }>()
);

export const deleteFocusAreaConfig = createAction(
  '[Global Settings] Delete Focus Area Config',
  props<{ focusAreaConfigId: string }>()
);

export const deleteFocusAreaConfigSuccess = createAction(
  '[Global Settings] Delete Focus Area Config Success'
);

export const updateFocusAreaConfigForm = createAction(
  '[Global Settings] Update Focus Area Config from Form',
  props<{ focusAreaConfigId: string }>()
);

export const updateFocusAreaConfigFormSuccess = createAction(
  '[Global Settings] Update Focus Area Config from Form Success',
  props<{ focusAreaConfig: FocusAreaConfigViewModel }>()
);
